const categories = [
    {value: "Plomeria", label: " Plomeria"},
    {value: "Electricidad", label: "Electricidad"},
    {value: "Mecanica", label: "Mecanica"},
    {value: "Carpinteria", label: "Carpinteria"},
    {value: "Gas Natural", label: "Gas Natural"},
];
const scopesC = [{value:"CABA",label: "CABA"},{value:"GBA SUR",label: "GBA SUR"},{value:"GBA NORTE",label: "GBA NORTE"},{value:"GBA ESTE",label: "GBA ESTE"}, {value:"GBA OESTE",label: "GBA OESTE"},   ];
const scopes =["CABA", "GBA SUR", "GBA NORTE", "GBA ESTE", "GBA OESTE"]
export {categories, scopesC, scopes}